import { useContext } from "react";
import { ClientContext } from "./context";

export function useClientHook() {
  return useContext(ClientContext);
}
